import React from 'react';

import { TYPES } from '../actions/modal';
import { Modal } from '../components/material-ui/Modal';
import { useModalWrapperProps } from '../selectors/modals';
import { AirportServiceModal } from './AirportServiceModal/AirportServiceModal';
import { ChangeUser } from './ChangeUser/ChangeUser';
import { CheckListModal } from './CheckListModal/CheckListModal';
import { DialogDateTimePicker } from './DialogDateTimePicker/DialogDateTimePicker';
import { EmployeeModal } from './EmployeeModal/EmployeeModal';
import { FlightTaskModal } from './FlightTaskModal/FlightTaskModal';
import { NoticeModal } from './NoticeModal/NoticeModal';
import { Passenger } from './Passenger/Passenger';
import { AlternateRoute, CheckAltitude, Comment, Direct, Hold, MultieditPoint, Offset, Point, ShortPoint, SpecialPoint } from './Point';
import { Relogin } from './Relogin/Relogin';
import { Report } from './Report/Report';
import { ReportDetail } from './ReportDetail/ReportDetail';
import { ReportFilter } from './ReportFilter/ReportFilter';
import { ReportsLoading } from './ReportsLoading/ReportsLoading';
import { RestoreModal } from './RestoreModal/RestoreModal';
import { SendedDataModal } from './SendedDataModal/SendedDataModal';
import { Setting } from './Setting/Setting';
import { Signature } from './Signature/Signature';
import { SummaryCrewLegModal } from './SummaryCrewLegModal/SummaryCrewLegModal';
import { TelegramViewer } from './TelegramViewer/TelegramViewer';
import { WhatsNewModal } from './WhatsNewModal/WhatsNewModal';

const getModalComponent = () => ({
    [TYPES.ALTERNATE_ROUTE]: AlternateRoute,
    [TYPES.CHANGE_USER]: ChangeUser,
    [TYPES.CHECK_ALTITUDE]: CheckAltitude,
    [TYPES.CHECK_LIST]: CheckListModal,
    [TYPES.COMMENT]: Comment,
    [TYPES.DATE_TIME_PICKER]: DialogDateTimePicker,
    [TYPES.DIRECT]: Direct,
    [TYPES.EMPLOYEE]: EmployeeModal,
    [TYPES.FLIGHT_TASK]: FlightTaskModal,
    [TYPES.HOLD]: Hold,
    [TYPES.MULTIEDIT]: MultieditPoint,
    [TYPES.NOTICE]: NoticeModal,
    [TYPES.OFFSET]: Offset,
    [TYPES.PASSENGER]: Passenger,
    [TYPES.POINT]: Point,
    [TYPES.RELOGIN]: Relogin,
    [TYPES.REPORT_DETAIL]: ReportDetail,
    [TYPES.REPORT]: Report,
    [TYPES.REPORT_FILTER]: ReportFilter,
    [TYPES.REPORTS_LOADING]: ReportsLoading,
    [TYPES.RESTORE]: RestoreModal,
    [TYPES.SEND_DATA]: SendedDataModal,
    [TYPES.SERVICE]: AirportServiceModal,
    [TYPES.SETTING]: Setting,
    [TYPES.SIGNATURE]: Signature,
    [TYPES.SHORT_POINT]: ShortPoint,
    [TYPES.SPECIAL_POINT]: SpecialPoint,
    [TYPES.SUMMARY_CREW_LEG]: SummaryCrewLegModal,
    [TYPES.TELEGRAM_VIEWER]: TelegramViewer,
    [TYPES.WHATS_NEW]: WhatsNewModal,
});

const CustomModal = ({ hideModal }) => {
    const { modalProps, modalType } = useModalWrapperProps();
    if (!modalType) {
        return null;
    }
    const ModalComponent = getModalComponent(modalProps.type)[modalType];

    return (
        ModalComponent && (
            <Modal onClose={hideModal} open={!!modalType}>
                <ModalComponent {...modalProps} />
            </Modal>
        )
    );
};

export { CustomModal as Modal };
